import { render, staticRenderFns } from "./EventsCardsList.vue?vue&type=template&id=6f875880&scoped=true"
import script from "./EventsCardsList.vue?vue&type=script&lang=js"
export * from "./EventsCardsList.vue?vue&type=script&lang=js"
import style0 from "./EventsCardsList.vue?vue&type=style&index=0&id=6f875880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f875880",
  null
  
)

export default component.exports